export default "__VITE_ASSET__3SSQCpQ0__"